import RateList from './RateList'

export default RateList